"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.name = void 0;
const React = __importStar(require("react"));
const react_native_1 = require("react-native");
const native_1 = require("@react-navigation/native");
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const modal_1 = require("components/modal");
const orders_1 = require("components/partial/orders");
const MyShoppingCart_1 = require("components/partial/MyShoppingCart");
const FullScreenLoad_1 = __importDefault(require("components/custom/FullScreenLoad"));
const services_1 = require("services");
const icons_1 = __importDefault(require("constants/icons"));
const context_1 = require("components/context");
const hooks_1 = require("components/hooks");
const giftWidth = 140;
var DeliveryType;
(function (DeliveryType) {
    DeliveryType["DELIVERY"] = "1";
    DeliveryType["PICK_UP"] = "2";
})(DeliveryType || (DeliveryType = {}));
const PurchaseSummary = ({ navigation, route }) => {
    const { warehouseCode, quoteClientId } = route?.params || {};
    const authContext = React.useContext(context_1.AuthContext);
    const toast = (0, native_base_1.useToast)();
    const modalRef = React.createRef();
    const flatListRef = React.useRef();
    const flatListOffsetX = React.useRef(0);
    const client = (0, hooks_1.useClient)();
    const [showGiftArea, setShowGiftArea] = React.useState(false);
    const [giftBalance, setGiftBalance] = React.useState(undefined);
    const [merchs, setMerchs] = React.useState();
    const [merchListResponse, setMerchListResponse] = React.useState();
    const [address, setAddress] = React.useState(null);
    const [transport, setTransport] = React.useState(null);
    const [wharehouse, setWharehouse] = React.useState();
    const [merch1x1ImageError, setMerch1x1ImageError] = React.useState(false);
    React.useEffect(() => {
        if (wharehouse)
            return;
        const onSuccess = (response) => {
            setWharehouse(response.response?.whs);
        };
        (0, services_1.doAlmacenes)({
            params: {
                data: {
                    id: warehouseCode,
                },
            },
            callback: {
                onSuccess,
            },
        });
    }, [warehouseCode]);
    const isTransportCompanyVisible = () => address?.reqtransport == "S" && wharehouse?.showTransportes == true;
    const onSelectedAddress = (address) => {
        setAddress(address);
    };
    const onSelectedTransport = (transport) => {
        setTransport(transport);
    };
    const [radioValue, setRadioValue] = React.useState(DeliveryType.DELIVERY);
    const [shoppingCartResponse, setShoppingCartResponse] = React.useState();
    const carritoList = async () => {
        const onSuccess = (response) => {
            setShoppingCartResponse(response);
        };
        const onFailSessionExpired = authContext?.signOut;
        (0, services_1.doCarritoList)({
            params: {
                clientId: quoteClientId,
            },
            callback: {
                onSuccess: onSuccess,
                onFailSessionExpired,
            },
        });
    };
    const merchList = async () => {
        const onSuccess = (response) => {
            setMerchListResponse(response);
        };
        const onFailSessionExpired = authContext?.signOut;
        (0, services_1.doMerchList)({
            params: {
                cliid: quoteClientId,
            },
            callback: {
                onSuccess: onSuccess,
                onFailSessionExpired,
            },
        });
    };
    const [comment, setComment] = React.useState("");
    const handleCommentChange = (e) => {
        const reg = new RegExp("[^0-9a-zA-ZñÑ@. ]");
        if (e.target.value?.length <= 250) {
            setComment(e.target.value.replace(reg, ""));
        }
    };
    React.useEffect(() => {
        console.log("--------------");
        console.log("shoppingCartResponse?.total", shoppingCartResponse?.totalValue);
        const mergesWithout1x1 = merchListResponse?.data?.filter(e => {
            return e.merch1x1 == false;
        });
        console.log("mergesWithout1x1", mergesWithout1x1, merchListResponse?.data);
        const shoppingCartBalance = (Number(shoppingCartResponse?.totalValue ?? "0") ?? 0) * ((client?.porcMerch ?? 0) / 100);
        console.log("client?.porcMerch", client?.porcMerch);
        console.log("shoppingCartBalance", shoppingCartBalance);
        let merchantBalance = 0;
        mergesWithout1x1?.forEach(e => {
            merchantBalance += (e.precioConIgv ?? 0) * (e.stock ?? 0);
        });
        console.log("merchantBalance", merchantBalance);
        const finalBalance = merchantBalance < shoppingCartBalance ? merchantBalance : shoppingCartBalance;
        console.log("finalBalance", finalBalance);
        //buscamos si exite algun producto con menor precio que nuestro saldo para poder agregarlo
        const hasAvailableProduct = mergesWithout1x1?.find(e => {
            const number = Number(e.precioConIgv ?? "0");
            const rest = number < finalBalance;
            console.log("number", number, "rest", rest);
            return rest;
        }) != null;
        console.log("hasAvailableProduct", hasAvailableProduct, "authContext?.loginData?.uidtipo", authContext?.loginData?.uidtipo);
        setGiftBalance(Number(finalBalance.toFixed(2)));
        setShowGiftArea(
        /*authContext?.loginData?.uidtipo == "SN" &&*/ //haydn pidio quitar la validacion que solo al sn le salga el merch
        finalBalance > 0 && hasAvailableProduct);
        setMerchs(merchListResponse?.data?.filter(e => {
            return (e.precioConIgv ?? 0) <= finalBalance && e.merch1x1 != true;
        }));
    }, [shoppingCartResponse?.total, merchListResponse?.data?.length]);
    //clear screen
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        carritoList();
        merchList();
        return () => {
            setAddress(null);
            setTransport(null);
            setWharehouse(undefined);
            setRadioValue(DeliveryType.DELIVERY);
            setShoppingCartResponse(undefined);
            setMerchListResponse(undefined);
            setComment("");
            navigation.setParams({
                warehouseCode: "",
                quoteClientId: "",
                quoteId: "",
            });
            // Do something when the screen is unfocused
            // Useful for cleanup functions
        };
    }, []));
    const [showModalSummary, setShowModalSummary] = React.useState(false);
    const [purchaseResponse, setPurchaseResponse] = React.useState();
    const isButtonDisabled = () => radioValue == DeliveryType.DELIVERY &&
        (address == null || (address != null && isTransportCompanyVisible() == true && transport == null));
    const [isLoading, setIsLoading] = React.useState(false);
    const isLoadingConfirm = React.useRef(false);
    const onConfirmShoppingClick = () => {
        if (isLoadingConfirm.current)
            return;
        isLoadingConfirm.current = true;
        if (radioValue == DeliveryType.DELIVERY && isTransportCompanyVisible() && transport == null) {
            modalRef.current?.onOpen();
            toast.show({ description: "Seleccione una empresa de transporte" });
            return;
        }
        const onLoading = (loading) => {
            isLoadingConfirm.current = loading;
            setIsLoading(loading);
        };
        const merch1x1 = merchListResponse?.data?.find(e => e.merch1x1 == true);
        const merchToSend = {
            codigo: merch1x1?.itemCode,
            nombre: merch1x1?.itemName,
            precio: merch1x1?.precio,
            cantidad: merch1x1?.cantidad?.toString(),
            linea: merch1x1?.linea,
            tipoDescuento: merch1x1?.tipoDescuento,
        };
        const merchsToSend = merchs
            ?.filter(e => (e.cantidad ?? 0) > 0)
            ?.map(item => {
            const merch = {
                codigo: item.itemCode,
                nombre: item.itemName,
                precio: item.precio,
                cantidad: item.cantidad?.toString(),
                linea: item.linea,
                tipoDescuento: item.tipoDescuento,
            };
            return merch;
        });
        (0, services_1.doCarritoMerch)({
            params: {
                cliid: quoteClientId,
                data: [...(merchsToSend ?? []), merchToSend],
            },
            callback: {
                onLoading,
                onSuccess: res => {
                    const onSuccess = (response) => {
                        setComment("");
                        setPurchaseResponse(response);
                        setShowModalSummary(true);
                        setRadioValue(DeliveryType.DELIVERY);
                    };
                    const onFail = (error) => {
                        setPurchaseResponse({ msg: error });
                        setShowModalSummary(true);
                        setRadioValue(DeliveryType.DELIVERY);
                    };
                    const onFailSessionExpired = authContext?.signOut;
                    (0, services_1.doCarritoConfirm)({
                        params: {
                            cliid: quoteClientId,
                            data: {
                                comentario: comment,
                                tipodespacho: radioValue,
                                direccion: radioValue == DeliveryType.DELIVERY ? address?.direccion : null,
                                iddireccion: address?.id,
                                transporte: transport?.rzonsocialtransp,
                                idtransporte: transport?.id,
                                direcciontransporte: transport?.direccion,
                                idtransportista: transport?.idtransportista,
                                CodigoMedioTransporte: radioValue == DeliveryType.DELIVERY ? address?.CodigoMedioTransporte : "",
                                idCotizacion: route?.params?.quoteId,
                            },
                        },
                        callback: {
                            onSuccess,
                            onFail,
                            onLoading,
                            onFailSessionExpired,
                        },
                    });
                },
            },
        });
    };
    const onBackPres = () => {
        navigation.navigate({
            name: MyShoppingCart_1.name,
            params: {
                warehouseCode: route.params.warehouseCode,
                quoteClientId: route.params.quoteClientId,
                quoteId: route.params.quoteId,
            },
            merge: true,
        });
    };
    const onMerchBackPressed = () => {
        /*flatListRef.current.scrollToIndex({
            index: 0,
            animated: false,
        });*/
        flatListRef.current.scrollToOffset({
            offset: flatListOffsetX.current - giftWidth,
            animated: true,
        });
    };
    const onMerchNextPressed = () => {
        /*flatListRef.current.scrollToIndex({
            index: 1,
            animated: false,
        });*/
        console.log(flatListRef.current);
        console.log(flatListRef.current.__proto__);
        flatListRef.current.scrollToOffset({
            offset: flatListOffsetX.current + giftWidth,
            animated: true,
        });
    };
    const onMinusPress = (item) => {
        const newMerchs = merchs?.map(e => {
            if (e.itemCode == item.itemCode && (e.cantidad ?? 0) > 0)
                e.cantidad = (e.cantidad ?? 0) - (e.SalPackUn ?? 1);
            return e;
        });
        setMerchs(newMerchs);
    };
    const onPlusPress = (item) => {
        //saldo ya gastado
        let balanceUsed = 0;
        merchs?.forEach(item => {
            balanceUsed += (item.precioConIgv ?? 0) * (item.cantidad ?? 0);
        });
        //saldo disponible
        let balanceAvailable = (giftBalance ?? 0) - balanceUsed;
        if (item.control == true && (item.cantidad ?? 0) == (item.stock ?? 0)) {
            if (!toast.isActive("unique-id-d"))
                toast.show({
                    id: "unique-id-d",
                    description: "¡Oops! Has alcanzado el límite de regalos permitidos en tu pedido.",
                });
            return;
        }
        const newMerchs = merchs?.map(e => {
            if (e.itemCode == item.itemCode && (e.precioConIgv ?? 0) * (e.SalPackUn ?? 1) > balanceAvailable) {
                if (!toast.isActive("unique-id"))
                    toast.show({
                        id: "unique-id",
                        description: "Saldo insuficiente",
                    });
                return e;
            }
            if (e.itemCode == item.itemCode)
                e.cantidad = (e.cantidad ?? 0) + (e.SalPackUn ?? 1);
            return e;
        });
        setMerchs(newMerchs);
    };
    const onMerch1MinusPressed = () => {
        const newMerchs = merchListResponse?.data?.map(e => {
            if (e.merch1x1 == true && (e.cantidad ?? 0) > 0)
                e.cantidad = (e.cantidad ?? 0) - 1;
            return e;
        });
        setMerchListResponse({
            op: "",
            status: 0,
            reason: 0,
            msg: "",
            data: newMerchs,
        });
    };
    const onMerch1PlusPressed = () => {
        const sizeBrandProd = shoppingCartResponse?.data
            ?.filter(e => e.marca == merchListResponse?.data?.find(e => e.merch1x1 == true)?.marcaId)
            ?.map(e => Number(e.cantidad ?? "0"))
            ?.reduce((prev, curr) => {
            return prev + curr;
        }, 0) ?? 0;
        console.log("sizeBrandProd", sizeBrandProd);
        const merch1x1 = merchListResponse?.data?.find(e => e.merch1x1 == true);
        const stock = merch1x1?.stock ?? 0;
        const min = stock < sizeBrandProd ? stock : sizeBrandProd;
        if ((merch1x1?.cantidad ?? 0) >= min) {
            if (!toast.isActive("unique-id-o"))
                toast.show({
                    id: "unique-id-o",
                    description: "¡Oops! Has alcanzado el límite de regalos permitidos en tu pedido.",
                });
            return;
        }
        const newMerchs = merchListResponse?.data?.map(e => {
            if (e.merch1x1 == true && (e.cantidad ?? 0) < (min ?? 0))
                e.cantidad = (e.cantidad ?? 0) + 1;
            return e;
        });
        setMerchListResponse({
            op: "",
            status: 0,
            reason: 0,
            msg: "",
            data: newMerchs,
        });
    };
    const renderItem = ({ item }) => {
        return <MerchItem item={item} onMinusPress={onMinusPress} onPlusPress={onPlusPress}/>;
    };
    console.log("merchListResponse?.data?.find(e => e.merch1x1 == true)?.urlImage", merchListResponse?.data?.find(e => e.merch1x1 == true)?.urlImage);
    return (<>
			<native_base_1.ScrollView style={styles.sv} _contentContainerStyle={{
            p: {
                base: 20,
                md: 30,
            },
        }}>
				<PurchaseSummaryModal showModal={showModalSummary} setShowModal={setShowModalSummary} purchaseResponse={purchaseResponse}/>
				<native_base_1.HStack alignItems="center">
					<native_base_1.Pressable onPress={onBackPres}>
						<native_base_1.Image width={15} height={15} marginRight="10" source={require("images/ic_back.svg")} alt={theme_1.Str.alt.ic_back}/>
					</native_base_1.Pressable>
					<native_base_1.Heading style={styles.txtTitle} variant="h1">
						{theme_1.Str.orderSummary}
					</native_base_1.Heading>
				</native_base_1.HStack>

				<native_base_1.View style={styles.layoutBoxPrices}>
					<native_base_1.VStack style={styles.layoutBox} minW={{ base: "100%", md: 400 }} p={{ base: 15, md: 30 }}>
						<native_base_1.Text color="colorDarkGray1" variant="body6" textTransform="uppercase">
							{theme_1.Str.dispatchType}
						</native_base_1.Text>
						<native_base_1.Radio.Group value={radioValue} name="name" mt="10" onChange={newValue => {
            setRadioValue(newValue);
        }}>
							<native_base_1.HStack>
								<native_base_1.Radio value={DeliveryType.DELIVERY}>{theme_1.Str.delivery2}</native_base_1.Radio>
								<native_base_1.Radio value={DeliveryType.PICK_UP} ml="20">
									{theme_1.Str.pickUpInWarehouse}
								</native_base_1.Radio>
							</native_base_1.HStack>
						</native_base_1.Radio.Group>

						<>
							<SelecAddressModal quoteClientId={quoteClientId} isVisible={radioValue == DeliveryType.DELIVERY} onSelectedAddress={onSelectedAddress} warehouseCode={warehouseCode} modalRef={modalRef}/>

							<SelectTransportCompanyModal quoteClientId={quoteClientId} isVisible={isTransportCompanyVisible() && radioValue == DeliveryType.DELIVERY} onSelectedTransport={onSelectedTransport}/>
						</>

						{radioValue == DeliveryType.PICK_UP && (<>
								<native_base_1.Text color="colorDarkGray1" variant="body6" textTransform="uppercase" mt="20">
									{theme_1.Str.addressOfPickUp}
								</native_base_1.Text>
								<native_base_1.HStack mt="5" alignItems="center">
									<native_base_1.Image source={icons_1.default.icMarker} w="13" h="13"/>
									<native_base_1.Text variant="body6" ml="5">
										{wharehouse?.direccion ?? wharehouse?.whsName}
									</native_base_1.Text>
								</native_base_1.HStack>
							</>)}

						<Products items={shoppingCartResponse?.data} size={shoppingCartResponse?.totalItems ?? ""}/>

						{merchListResponse?.data?.find(e => e.merch1x1 == true) && (<native_base_1.View w="100%" mt={20}>
								<native_base_1.Image borderRadius={14} w="100%" h={undefined} style={{ aspectRatio: 2 / 1 }} resizeMode="cover" source={{
                uri: merchListResponse?.data?.find(e => e.merch1x1 == true)?.urlImage,
            }} onError={() => {
                setMerch1x1ImageError(true);
            }}/>

								{merch1x1ImageError && (<native_base_1.View borderRadius={14} w="100%" h={undefined} style={{ aspectRatio: 2 / 1 }}/>)}

								<native_base_1.View position="absolute" w={"100%"} alignItems="center" justifyContent="center" bottom={10} right={0} left={0}>
									<native_base_1.HStack borderColor="colorDarkGray1" borderWidth={1} borderRadius={30} p="1" minW="100" alignItems="center" alignSelf="center" justifyContent="center" bg="white">
										<native_base_1.Pressable onPress={onMerch1MinusPressed}>
											<native_base_1.Image source={icons_1.default.icMinus} w={15} h={15} ml={10} mr={1} my={2}/>
										</native_base_1.Pressable>
										<native_base_1.Text variant="h3" minW={35} textAlign="center">
											{merchListResponse?.data?.find(e => e.merch1x1 == true)?.cantidad ?? "0"}
										</native_base_1.Text>
										<native_base_1.Pressable onPress={onMerch1PlusPressed}>
											<native_base_1.Image source={icons_1.default.icPlus} w={15} h={15} ml={1} mr={10} my={2}/>
										</native_base_1.Pressable>
									</native_base_1.HStack>
								</native_base_1.View>
							</native_base_1.View>)}

						{showGiftArea && (<>
								<native_base_1.HStack mt={15} alignItems="center">
									<native_base_1.Text variant="h2" flex={1}>
										{theme_1.Str.addYourGift}
									</native_base_1.Text>
									<native_base_1.HStack bg="colorVividYellow1" borderRadius={19} px={12} py={2}>
										<native_base_1.Text variant="body5">{`${theme_1.Str.balance}: ${giftBalance}`}</native_base_1.Text>
									</native_base_1.HStack>
								</native_base_1.HStack>

								<native_base_1.HStack mt={10} alignItems="center">
									<native_base_1.Pressable onPress={onMerchBackPressed}>
										<native_base_1.Image source={icons_1.default.icBack} width={20} height={20}/>
									</native_base_1.Pressable>
									<native_base_1.View flex={1}>
										<native_base_1.FlatList showsHorizontalScrollIndicator={false} ref={flatListRef} horizontal data={merchs} renderItem={renderItem} onScroll={(event) => {
                const slideSize = event.nativeEvent.layoutMeasurement.width;
                const index = event.nativeEvent.contentOffset.x / slideSize;
                const roundIndex = Math.round(index);
                flatListOffsetX.current = event.nativeEvent.contentOffset.x;
                console.log("event.nativeEvent.contentOffset:", event.nativeEvent.contentOffset.x);
                console.log("roundIndex:", roundIndex);
            }}/>
									</native_base_1.View>
									<native_base_1.Pressable onPress={onMerchNextPressed}>
										<native_base_1.Image source={icons_1.default.icBack} width={20} height={20} style={{
                transform: [{ rotate: "180deg" }],
            }}/>
									</native_base_1.Pressable>
								</native_base_1.HStack>
							</>)}

						<native_base_1.Text style={[styles.txtComment]} variant="h2">
							{theme_1.Str.comment}
						</native_base_1.Text>
						<native_base_1.TextArea style={styles.inputComment} value={comment} onChange={handleCommentChange} placeholder="Max 120 caracteres" maxLength={120}/>
					</native_base_1.VStack>

					<native_base_1.VStack style={styles.layoutPrices} minW={{ base: "100%", md: 300 }} ml={{ base: 0, md: 20 }}>
						<native_base_1.HStack style={[styles.layoutPricesTitleValue]}>
							<native_base_1.Text style={[styles.txtPriceTitle]} variant="body23">
								{theme_1.Str.subtotal}
							</native_base_1.Text>
							<native_base_1.Text variant="body23">{shoppingCartResponse?.subtotal ?? ""}</native_base_1.Text>
						</native_base_1.HStack>
						<native_base_1.HStack style={[styles.layoutPricesTitleValue, styles.layoutDiscount1]}>
							<native_base_1.Text style={[styles.txtPriceTitle]} variant="body23">
								IGV (18%)
							</native_base_1.Text>
							<native_base_1.Text variant="body23">{shoppingCartResponse?.igv ?? ""}</native_base_1.Text>
						</native_base_1.HStack>
						<native_base_1.HStack style={[styles.layoutPricesTitleValue, styles.layoutPricesTotal]}>
							<native_base_1.Text style={[styles.txtPriceTitle, styles.txtPriceTotal]} variant="h23">
								{theme_1.Str.total}
							</native_base_1.Text>
							<native_base_1.Text style={[styles.txtPriceTotal]} variant="h23">
								{shoppingCartResponse?.total ?? ""}
							</native_base_1.Text>
						</native_base_1.HStack>
						<native_base_1.Button isLoading={isLoading} isDisabled={isButtonDisabled()} onPress={onConfirmShoppingClick} style={styles.btnConfirmPurchase} endIcon={<native_base_1.Image ml="10" source={require("images/ic_check.svg")} variant="iconInputRight"/>} w={{ base: "100%", md: "auto" }} textTransform="uppercase">
							{theme_1.Str.confirmOrder}
						</native_base_1.Button>
					</native_base_1.VStack>
				</native_base_1.View>
			</native_base_1.ScrollView>
			<FullScreenLoad_1.default isVisible={isLoading}/>
		</>);
};
const SelecAddressModal = ({ quoteClientId, onSelectedAddress, isVisible, warehouseCode, modalRef, }) => {
    const [value, setValue] = React.useState(theme_1.Str.selectAnOption);
    const [showModal, setShowModal] = React.useState(false);
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        return () => {
            setValue("");
        };
    }, []));
    return (<>
			<modal_1.ModalSelectAddress quoteClientId={quoteClientId} onListAddressSuccess={(addresses) => {
            if (addresses.length == 1) {
                setValue(addresses?.[0]?.direccion);
                onSelectedAddress(addresses?.[0]);
            }
        }} onSelectedAddress={(address) => {
            setValue(address?.direccion);
            setShowModal(false);
            onSelectedAddress(address);
        }} isOpen={showModal} onClose={() => setShowModal(false)} ref={modalRef}/>
			<Spinner title={theme_1.Str.deliveryAddress} value={value} onPress={() => {
            setShowModal(true);
            modalRef.current?.onOpen();
        }} mt="20" display={isVisible ? "flex" : "none"}/>
		</>);
};
const SelectTransportCompanyModal = ({ quoteClientId, onSelectedTransport, isVisible, }) => {
    const [value, setValue] = React.useState(theme_1.Str.selectAnOption);
    const [showModal, setShowModal] = React.useState(false);
    return (<>
			{isVisible && (<modal_1.ModalSelectTransportCompany quoteClientId={quoteClientId} onSelectedTransport={(address) => {
                setValue(address.rzonsocialtransp);
                setShowModal(false);
                onSelectedTransport(address);
            }} onListAddressSuccess={(addresses) => {
                if (addresses?.length == 1) {
                    setValue(addresses?.[0]?.rzonsocialtransp);
                    onSelectedTransport(addresses?.[0]);
                }
                else if (addresses?.length == 0) {
                    setValue(theme_1.Str.selectAnOption);
                    onSelectedTransport(null);
                }
            }} isOpen={showModal} onClose={() => setShowModal(false)}/>)}

			<Spinner onPress={() => setShowModal(true)} title={theme_1.Str.transportCompany} value={value} mt={{
            base: 10,
            md: 30,
        }} display={isVisible ? "flex" : "none"}/>
		</>);
};
const PurchaseSummaryModal = ({ showModal, setShowModal, purchaseResponse }) => {
    const navigation = (0, native_1.useNavigation)();
    return (<>
			<modal_1.ModalPurchaseSummary onOkPress={() => {
            setShowModal(false);
            navigation?.navigate(orders_1.name);
        }} purchaseResponse={purchaseResponse} isOpen={showModal} onClose={() => {
            setShowModal(false);
            navigation?.navigate(orders_1.name);
        }}/>
		</>);
};
const Spinner = ({ onPress, title, value, ...rest }) => {
    return (<native_base_1.Pressable onPress={onPress} {...rest}>
			<native_base_1.View>
				<native_base_1.HStack style={{
            marginTop: 20,
            paddingHorizontal: 20,
            paddingVertical: 10,
            alignItems: "center",
            borderColor: "black",
            borderWidth: 2,
            borderRadius: theme_1.Sizes.configRadius,
        }}>
					<native_base_1.Text style={{
            flex: 1,
            marginEnd: 10,
        }}>
						{value ?? theme_1.Str.selectAnOption}
					</native_base_1.Text>
					<native_base_1.Image source={require("images/ic_more.svg")} style={{
            width: 13,
            height: 13,
        }}/>
				</native_base_1.HStack>
				<native_base_1.Text style={{
            start: 15,
            top: 10,
        }} position="absolute" top="10" px="10" bg="white" color="colorDarkGray1" variant="body6">
					{title.toUpperCase()}
				</native_base_1.Text>
			</native_base_1.View>
		</native_base_1.Pressable>);
};
const Products = ({ items, size }) => {
    return (<>
			<native_base_1.HStack w="100%" mt="30">
				<native_base_1.Text variant="h2" flex="1">
					{theme_1.Str.products}
				</native_base_1.Text>
				<native_base_1.Text variant="h2">{size ? `(${size ?? ""})` : ""}</native_base_1.Text>
			</native_base_1.HStack>

			<native_base_1.FlatList data={items} renderItem={({ item }) => (<native_base_1.HStack justifyContent="space-between">
						<native_base_1.Text style={styles.txtBattery}>{item.nombre ?? ""}</native_base_1.Text>
						<native_base_1.Text style={styles.txtBattery} ml="10">
							{item.cantidad ?? ""}
						</native_base_1.Text>
					</native_base_1.HStack>)}/>
		</>);
};
const MerchItem = ({ item, onPlusPress, onMinusPress }) => {
    const onMinusPressInternal = () => {
        onMinusPress(item);
    };
    const onPlusPressInternal = () => {
        onPlusPress(item);
    };
    return (<native_base_1.VStack mr={10} alignItems="center">
			<native_base_1.Text maxW={150} variant="body6" textAlign="center" numberOfLines={3} noOfLines={3} style={{ height: "3rem" }}>
				{item.itemName ?? ""}
			</native_base_1.Text>
			<native_base_1.ZStack w={giftWidth} h={170} borderWidth={1} borderColor="colorDarkGray1" borderRadius={10} my={10}>
				<native_base_1.Image source={{ uri: item.urlImage, width: giftWidth, height: 170 }} width={giftWidth} height={170}/>
			</native_base_1.ZStack>

			<native_base_1.HStack borderColor="colorDarkGray1" borderWidth={1} borderRadius={30} p="1" minW="100" alignItems="center" justifyContent="center">
				<native_base_1.Pressable onPress={onMinusPressInternal}>
					<native_base_1.Image source={icons_1.default.icMinus} w={15} h={15} ml={10} mr={1} my={2}/>
				</native_base_1.Pressable>
				<native_base_1.Text variant="h3" minW={35} textAlign="center">
					{item.cantidad ?? "0"}
				</native_base_1.Text>
				<native_base_1.Pressable onPress={onPlusPressInternal}>
					<native_base_1.Image source={icons_1.default.icPlus} w={15} h={15} ml={1} mr={10} my={2}/>
				</native_base_1.Pressable>
			</native_base_1.HStack>
		</native_base_1.VStack>);
};
const styles = react_native_1.StyleSheet.create({
    sv: {
        width: "100%",
    },
    txtTitle: {},
    layoutBoxPrices: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    layoutBox: {
        flex: 1,
        marginTop: 30,
        backgroundColor: "white",
        borderRadius: theme_1.Sizes.configRadius,
    },
    txtBattery: {
        marginTop: 20,
    },
    txtComment: {
        marginTop: 30,
    },
    inputComment: {
        minHeight: 100,
        marginTop: 20,
        borderRadius: theme_1.Sizes.configRadius,
        borderWidth: 2,
        borderColor: "black",
    },
    layoutPrices: {
        flex: 1,
        marginTop: 30,
        alignItems: "center",
    },
    layoutPricesTitleValue: {
        width: "100%",
        flexDirection: "row",
        alignItems: "center",
    },
    layoutDiscount1: {
        marginTop: 20,
    },
    layoutPricesTotal: {
        marginTop: 20,
        paddingTop: 20,
        borderTopColor: "black",
        borderTopWidth: 2,
    },
    txtPriceTitle: {
        flex: 1,
    },
    txtPriceTotal: {
        textTransform: "uppercase",
    },
    btnConfirmPurchase: {
        marginTop: 40,
    },
});
exports.name = "PurchaseSummaryName";
exports.default = PurchaseSummary;
